module.exports = __webpack_public_path__ + "static/media/teams-2.b57544fc.jpg";